export default __webpack_public_path__ + "static/media/history-icon.3f7aa0c8.svg";